import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SelfServiceService } from '../../../core/http/self-service.service';
import { SampleService } from '../../../core/http/sample.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-offline-appointment',
  templateUrl: './offline-appointment.component.html',
  styleUrls: ['./offline-appointment.component.scss'],
})
export class OfflineAppointmentComponent implements OnInit {
  isLoading = true;
  Errors = null;
  socs = null;
  mode = 'all';
  selectedDr;
  Success = null;
  return;
  drs: any = [];
  data: any = [];
  panelOpenState = false;
  app: any = [];
  details;

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public sample: SampleService,
    private self: SelfServiceService
  ) {}

  isJson(item) {
    item = typeof item !== 'string' ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === 'object' && item !== null) {
      return true;
    }

    return false;
  }

  ngOnInit(): void {
    this.self.getAppointmentsLocal().subscribe(
      (resSuccess: any) => {
        this.isLoading = false;

        let data = [];

        for (let i = 0; i < resSuccess.length; i++) {
          if (this.isJson(resSuccess[i].Comment)) {
            // resSuccess[i].Comment = JSON.parse(resSuccess[i].Comment);
            // data.push(resSuccess[i]);
            console.log(resSuccess[i].Comment);
            console.log(JSON.parse(resSuccess[i].Comment));
            console.log(typeof resSuccess[i].Comment);

            console.log('true');
          } else {
            data.push(resSuccess[i]);
            console.log('false');
            console.log(typeof resSuccess[i].Comment);
          }
        }
        this.data = resSuccess;
        console.log(this.data);
      },
      (resErr) => {
        this.Errors = resErr;
        this.isLoading = false;
      }
    );
  }

  view(app) {
    console.log(app);
    this.details = JSON.parse(app.Comment);
    console.log(this.details);
    this.app = app;
    this.mode = 'view';
  }

  back() {
    this.mode = 'all';
  }
}
